<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view v-if="isShow"/>
    </div>
  </a-config-provider>
</template>
<script>
  import { USER_LANGUAGE } from "@/store/mutation-types"
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
  import zhTW from 'ant-design-vue/lib/locale-provider/zh_TW'
  import viVN from 'ant-design-vue/lib/locale-provider/vi_VN'
  import enquireScreen from '@/utils/device'
  import moment from 'moment';
  import 'moment/locale/zh-cn';

  // Fontclass模式
  import '@/components/iconfont/common.less'
  // 使用 symbol模式 支持多色
  import '@/components/iconfont/iconfont.js'

  moment.locale('zh-cn');
  const EN = 'en_US'
  const CN = 'zh_CN'
  const TW = 'zh_TW'
  const VN = 'vi_VN'
  export default {
    data () {
      return {
        zhCN,
        zhTW,
        viVN,
        isShow: true
      }
    },
    // 提供可注入子组件属性
    provide () {
      return {
        reload: this.reload
      }
    },
    computed: {
      locale(){
        const local = window.sessionStorage.getItem(USER_LANGUAGE) || 'zh_CN'
        if (local === CN) {
          moment.locale(CN)
          return zhCN
        } else if(local === TW){
          moment.locale(TW)
          return zhTW
        }
        else if(local === VN){
          moment.locale(VN)
          return viVN
        } else {
          moment.locale(local)
          return null
        }

        /*moment.locale(local)
        return local*/
      },
    },
    created () {
      let that = this
      enquireScreen(deviceType => {
        // tablet
        if (deviceType === 0) {
          that.$store.commit('TOGGLE_DEVICE', 'mobile')
          that.$store.dispatch('setSidebar', false)
        }
        // mobile
        else if (deviceType === 1) {
          that.$store.commit('TOGGLE_DEVICE', 'mobile')
          that.$store.dispatch('setSidebar', false)
        }
        else {
          that.$store.commit('TOGGLE_DEVICE', 'desktop')
          that.$store.dispatch('setSidebar', true)
        }

      })
    },
    // 定义reload方法
    methods: {
      reload () {
        // 先隐藏
        this.isShow = false
        // $nextTick() 将回调延迟到下次 DOM 更新循环之后执行
        this.$nextTick(() => {
          this.isShow = true
        })
      }
    }
  }
</script>
<style>
  #app {
    height: 100%;
  }
</style>
<style scoped>
  @import '~@assets/less/common.less';
</style>